<template>
  <div class="form-container">
    <h1 class="page-title">顧客担当者マスタ情報新規作成</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
      <div class="mb-3">
        <label for="customer" class="form-label">顧客 <span class="badge text-bg-danger">必須</span></label>
        <CustomerSelectBox
          v-model="customer_representative.m_customer_id"
          :options="customers"
          :required="true"
        />
      </div>

      <div class="mb-3">
        <label for="inChargeDepartmentNm" class="form-label">担当部署名</label>
        <input v-model="customer_representative.in_charge_department_nm" type="text" placeholder="担当部署名" class="form-control" id="inChargeDepartmentNm">
        <div v-if="errorMessages.in_charge_department_nm" class="alert alert-danger mt-2">{{ errorMessages.in_charge_department_nm[0] }}</div>
      </div>

      <div class="d-flex">
        <div class="mb-3 me-3">
          <label for="inChargeLastNm" class="form-label">担当者名(姓)</label>
          <input v-model="customer_representative.in_charge_last_nm" type="text" placeholder="担当者名(姓)" class="form-control" id="inChargeLastNm">
          <div v-if="errorMessages.in_charge_last_nm" class="alert alert-danger mt-2">{{ errorMessages.in_charge_last_nm[0] }}</div>
        </div>

        <div class="mb-3">
          <label for="inChargeFirstNm" class="form-label">担当者名(名)</label>
          <input v-model="customer_representative.in_charge_first_nm" type="text" placeholder="担当者名(名)" class="form-control" id="inChargeFirstNm">
          <div v-if="errorMessages.in_charge_first_nm" class="alert alert-danger mt-2">{{ errorMessages.in_charge_first_nm[0] }}</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="inChargeEmail" class="form-label">担当者メールアドレス</label>
        <input v-model="customer_representative.in_charge_email" type="email" placeholder="担当者メールアドレス" class="form-control" id="inChargeEmail">
        <div v-if="errorMessages.in_charge_email" class="alert alert-danger mt-2">{{ errorMessages.in_charge_email[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="cal_destination_address_use_flg" class="ECM_CheckboxInput">
          <input
            v-model="customer_representative.cal_destination_address_use_flg"
            :true-value="true"
            :false-value="false"
            id="cal_destination_address_use_flg"
            type="checkbox"
            class="ECM_CheckboxInput-Input"
          >
          <span class="ECM_CheckboxInput-DummyInput"></span>
          <h4 class="ms-3">予定表送付先宛名で使用</h4>
        </label>
      </div>

      <div class="mb-3">
        <label for="bill_destination_address_use_flg" class="ECM_CheckboxInput">
          <input
            v-model="customer_representative.bill_destination_address_use_flg"
            :true-value="true"
            :false-value="false"
            id="bill_destination_address_use_flg"
            type="checkbox"
            class="ECM_CheckboxInput-Input"
          >
          <span class="ECM_CheckboxInput-DummyInput"></span>
          <h4 class="ms-3">請求書送付先宛名で使用</h4>
        </label>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-primary mx-1">登録</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {
  getSelectBoxCustomers,
  createCustomerRepresentative
} from '@/api/axios';
import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue';

export default {
  components: {
    CustomerSelectBox
  },
  setup() {
    const title = ref('顧客担当者情報新規作成');

    watchEffect(() => {
      document.title = title.value;
    });

    const customers = ref([]);
    const customer_representative = ref({
      m_customer_id: '',
      in_charge_department_nm: '',
      in_charge_last_nm: '',
      in_charge_first_nm: '',
      in_charge_email: '',
      cal_destination_address_use_flg: '',
      bill_destination_address_use_flg: '',
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const fetchCustomers = async () => {
      try {
        const [customerResponse] = await Promise.all([
          getSelectBoxCustomers(),
        ]);
        customers.value = customerResponse.data;
      } catch (error) {
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await createCustomerRepresentative(customer_representative.value);
        store.dispatch('setFlashMessage', {message: '顧客担当者情報作成完了！', type: 'success'});
        router.push({
          path: '/customer-representatives',
          query: route.query
        });
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }

        store.dispatch('setFlashMessage', {message: '顧客担当者情報作成失敗！', type: 'danger'});
        console.error('作成エラー:', error);
      }
    };

    onMounted(fetchCustomers);

    return {
      title,
      customers,
      customer_representative,
      handleSubmit,
      errorMessages
    };
  }
};
</script>
